exports.default = {
  'scroll_options_left': 'Scroll left for more options',
  'scroll_options_right': 'Scroll right for more options',
  'context_cleared': 'Context cleared',
  'select_all': 'Select all',
  'cancel': 'Cancel',
  'generate_share_link': 'Generate share link',
  'share_link_dialog_title': 'Share link generated',
  'share_link_dialog_description': 'Click Copy link to copy the share link to your clipboard.',
  'copy_share_link': 'Copy link',
  'add_to_project': 'Save to project',
  'this_agent_has_been_deleted': 'This agent has been deleted!',
  'this_agent_has_been_removed': 'This agent has been removed!',
  'please_enter_your_question_or_requirement': 'Send a message',
  'single_image_size_no_more_than_50M': 'Single image size should not exceed 20MB, up to 10 images can be uploaded at once.',
  'reference_image_upload_hint': 'Each image must not exceed 20MB. The current model supports up to {count} reference images.',
  'hello': 'Hello',
  'no_recommended_questions': 'No recommended questions',
  'loading_recommended_questions': 'Loading recommended questions:',
  'append_continue_answer': 'Append continuation of answer',
  'max_turns_stop_title': 'Execution paused',
  'max_turns_stop_description': 'This run reached the maximum number of execution steps. Your progress has been saved. Continue the remaining task?',
  'max_turns_continue': 'Continue generating',
  'max_turns_later': 'Later',
  'max_turns_continue_message': 'Continue',
  'max_turns_stop_toast': 'Maximum execution steps reached. You can continue after progress is saved.',

  'video_script_tools': {
    'loading': 'Loading script…',
    'directory_empty': 'No saved video scripts in this conversation',
    'content_empty': 'No script content available',
    'failed': 'The script operation failed. Please try again later.',
    'stopped': 'Script operation stopped',
    'more': 'More scripts are available. Continue querying to see them.',
    'revision': 'Version {revision}',
    'synced': 'Synced',
    'syncing': 'Syncing',
    'sync_failed': 'Sync failed',
    'sync_unknown': 'Sync status unknown',
  },
  'video_script_preview': {
    'title': 'Video script preview',
    'untitled': 'Untitled script',
    'status_writing': 'Writing',
    'status_saving': 'Saving',
    'status_syncing': 'Syncing',
    'save_success_requote': 'Script updated. Please request a new quote.',
    'status_saved': 'Saved',
    'status_error': 'Save failed',
    'error': 'Script save failed',
    'edit': 'Edit',
    'document': 'Document',
    'copy': 'Copy all',
    'download': 'Download',
    'copy_success': 'Copied',
    'loading': 'Loading',
    'save': 'Save new version',
    'cancel': 'Cancel',
    'content_placeholder': 'Edit the video script in Markdown',
    'content_required': 'Enter the script content',
    'retry': 'Reload',
    'load_failed': 'Failed to load the script',
    'save_failed': 'Failed to save the script. Your edits have been kept. Please try again later.',
    'save_auth_failed': 'Unable to save right now. Your edits are kept. Try again later.',
    'save_revision_conflict': 'A newer script version exists and cannot be overwritten. Your edits have been kept. Continue editing from the latest version.',
    'save_pending': 'The script is still syncing or saving. Your edits have been kept. Please try again later.',
  },
  'failed_to_load_chat_records': 'Failed to load chat records:',
  'error': 'Error occurred',
  'clear_failed_please_try_again_later': 'Clear failed, please try again later',
  'operation_failed_please_try_again_later': 'Operation failed, please try again later',
  'current_agent_does_not_support_image_function': 'Current agent does not support image function',
  'unsupported_image_format': 'Unsupported image format:',
  'upload_image_cannot_be_larger_than_50M': 'Uploaded image cannot be larger than 20MB',
  'files_current_selected_file_count': 'files, current selected file count',
  'upload_avatar_image_can_only_be_JPG_PNG_GIF_WEBP_format': 'Upload avatar image can only be JPG, PNG, GIF, WEBP format!',
  'upload_image_size_cannot_exceed_50M': 'Upload image size cannot exceed 20MB!',
  'upload_failed': 'Upload failed',
  'image_index_label': 'Image {index}',
  'image_saved_successfully': 'Image saved successfully',
  'failed_to_save_image': 'Failed to save image:',
  'image_save_failed': 'Image save failed',
  'loading_image': 'Loading image',
  'network_error': 'Network error, sending failed.',
  'copy': 'Copy',
  'share': 'Share',
  'save_note': 'Save note',
  'copy_success': 'Copy successful',
  'copy_failed': 'Copy failed, please try again later!',
  'timeout_retry': 'Response timeout, please try again later.',
  'regenerate': 'Remixes',
  'cancel_like': 'Cancel like',
  'good_answer': 'Good answer',
  'cancel_dislike': 'Cancel dislike',
  'not_good_enough': 'Not good enough',
  'close': 'Close',
  'submit': 'Submit',
  'dislike_reasons': {
    'not_good_enough': 'Not good enough',
    'irrelevant': 'Irrelevant to the question',
    'inaccurate': 'Content is inaccurate',
    'misinformation': 'Contains misinformation',
    'misleading_values': 'Misleading value orientation',
    'prejudice': 'Contains bias or discrimination',
    'violates_rights': 'Violates others\' rights',
    'other_feedback': 'Other feedback'
  },
  'select_dislike_reason': 'Please select your reason for disliking the content~~',
  'document_name': 'Document name',
  'enter_document_name': 'Please enter document name',
  'search_project': 'Search project',
  'add_as_subdocument': 'Add as subdocument',
  'add_as_subwebdocument': 'Add as sub-webpage',
  'unnamed_document': 'Unnamed document',
  'add_success': 'Added successfully',
  'get_recent_list_failed': 'Failed to get recent access list',
  'select_target_document': 'Select target document',
  'insert_current_document': 'Insert current document',
  'agent_deleted': 'This agent has been deleted!',
  'agent_taken_down': 'This agent has been taken down!',
  'enter_to_send': 'Send a message',
  'file_limit_error': 'You can select up to {multiLimit} files at a time, current selected file count is {filesLength}',
  'verification_failed': 'Verification failed',
  'loading': 'Loading',
  'no_more': 'No more',
  'operation_failed': 'Operation failed, please try again later',
  'load_chat_history_failed': 'Failed to load chat history: {message}',
  'clear_success': 'Cleared successfully',
  'clear_failed': 'Clear failed, please try again later',
  'quota_exceeded': 'Quota exceeded',
  'content_violation': 'Content violation',
  'unavailabled_agent': 'Model Unavailable',
  'click_to_update_model': 'Update Model',
  'input_length_exceeded': 'Input length exceeded',
  'point_not_enough': 'Insufficient points',
  'thinking': 'Thinking...',
  'processing_thinking': 'Thinking...',
  'processing_summarizing': 'Organizing conversation context...',
  'thinking_error': 'Thinking error',
  'thinking_start': 'Start thinking',
  'thinking_end': 'Thinking complete',
  'chat_system_is_busy': 'The system is busy,We are re-answering for you',
  'system_is_busy': 'The system is busy. Please try again later',
  'go_back': 'Go Back',
  'go': 'Go Forward',
  'refresh': 'Refresh',
  'full_screen': 'Full Screen',
  'new_link_open': 'Open in New Tab',
  'preview': 'Preview',
  'code': 'Code',
  'edit': 'Edit',
  'mobile_view': 'Mobile View',
  'desktop_view': 'Desktop View',
  'code_download': 'Download Code',
  'view_version_list': 'View Version List',
  'version_history': 'Version History',
  'version': 'Version: {version_number}',
  'generate_on': 'Generated on {date}',
  'current_version': 'Current',
  'version_switched': 'Switched to selected version',
  'no_version_download': 'No versions available for download',
  'download_start': 'Project download started',
  'version_loading': 'Loading..',
  'version_empty': 'No versions available',
  'version_nomore': 'No more versions',
  'version_status_ready': 'Ready',
  'version_status_fail': 'Fail',
  'version_status_building': 'Building',
  'open_web_editor': 'Preview webpage',
  'no_version_preview': 'No web version is available for preview',
  'close_web_mode': 'Close Web Mode',
  'web_build_error': 'This version could not be generated successfully, and a preview is not available.',
  'web_build_error_pls_fix': 'Project build error, fix it?',
  'web_error_fix': 'Fix',
  'repair_in_progress': 'Please wait, we are repairing your page',
  'file_directory': 'Project Structure',
  'choose_file_to_view': 'Select a file to view',
  'selectFile': 'Select a file from the left file tree to view the code',
  'maxSize': 'Max 5MB, supports common image formats',
  'uploadImage': 'Drop or paste image here, or click Upload',
  'text': 'Text',
  'no_text_content': 'No text content',
  'edit_text': 'Edit Text',
  'link': 'Link',
  'edit_link': 'Edit Link',
  'add_link': 'Add Link',
  'image': 'Image',
  'chat': 'Chat',
  'apply': 'Apply',
  'replace': 'Replace',
  'replace_image': 'Replace Image',
  'upload': 'Upload',
  'confirm_crop': 'Confirm Crop',
  'crop_ratio_auto': 'Adapt',
  'crop_ratio_free': 'Free',
  'crop_ratio_original': 'Original',
  'send': 'Send',
  'no_available_chat_mode': 'No chat modes available',
  'web_search': 'Web search',
  'web_search_description': 'Search the web for up-to-date information',
  'external_skill_entry': 'Skills',
  'external_skill_catalog': 'All skills',
  'external_skill_recent_used': 'Recently used',
  'external_skill_recent_empty': 'No usage history yet. Skills you use will appear here.',
  'external_skill_catalog_desc': 'Choose a custom skill available for the current agent type',
  'external_skill_refresh': 'Refresh',
  'external_skill_loading': 'Loading skills...',
  'external_skill_empty': 'No custom skills are available for this agent type',
  'external_skill_empty_presets': 'No presets available',
  'external_skill_all': 'All',
  'external_skill_catalog_suffix': ' skills',
  'external_skill_categories': 'Skill categories',
  'external_skill_search': 'Search skills',
  'external_skill_uncategorized': 'Other skills',
  'external_skill_preset': 'Skill preset',
  'external_skill_preview': 'Description preview',
  'external_skill_preview_action': 'Preview',
  'external_skill_insert': 'Insert into input',
  'external_skill_insert_description': 'Insert into description',
  'external_skill_generate': 'Generate',
  'external_skill_back': 'Back to all skills',
  'external_skill_examples': 'Skill examples',
  'external_skill_example_image': 'Example image {number}',
  'external_skill_example_video': 'Example video {number}',
  'external_skill_examples_empty': 'No image or video examples yet',
  'external_skill_example_loading': 'Loading examples…',
  'external_skill_example_failed': 'Example failed to load',
  'external_skill_example_headphones': 'Headphones product example',
  'external_skill_example_watch': 'Watch product example',
  'external_skill_example_camera': 'Camera product example',
  'external_skill_example_perfume': 'Perfume product example',
  'external_skill_no_fields': 'This preset needs no additional settings',
  'external_skill_load_failed': 'Failed to load skills. Please try again later.',
  'external_skill_detail_failed': 'Failed to load preset details',
  'external_skill_preview_failed': 'Failed to preview the description. Please try again later.',
  'external_skill_upload_image': 'Upload image',
  'external_skill_upload_file': 'Upload file',
  'external_skill_upload_too_large': 'The file is too large',
  'external_skill_upload_image_only': 'Please choose an image file',
  'external_skill_upload_type_not_allowed': 'This file type is not allowed by the preset',
  'external_skill_upload_failed': 'Upload failed. Please try again later.',
  'external_skill_upload_limit': 'The upload limit has been reached',
  'external_skill_field_required': 'Required',
  'external_skill_field_number': 'Enter a valid number',
  'external_skill_field_min': 'Minimum {min}',
  'external_skill_field_max': 'Maximum {max}',
  'external_skill_field_step': 'Step {step}',
  'external_skill_field_step_from': 'Start at {min}, step {step}',
  'external_skill_field_precision': 'Up to {precision} decimal places',
  'external_skill_field_min_length': 'Enter at least {min} characters',
  'external_skill_field_max_length': 'Enter no more than {max} characters',
  'external_skill_field_max_count': 'Select up to {count} items',
  'external_skill_field_option': 'Select a valid option',
  'external_skill_field_upload': 'Upload a valid file',
  'external_skill_field_max_size': 'Each file must be no larger than {size} MB',
  'external_skill_field_accept': 'Accepted formats: {accept}',
  'mixture_of_agents_brief': 'Automatically combine the best AI models for your task.',
  'element_chat': 'Element Chat',
  'ask_about_element': 'Ask something about this element...',
  'version_add_error': 'Version exception, cannot be added to the project',
  'web_error_regenerate': 'Regenerate',
  'conversation_not_exist': 'The conversation does not exist or has been deleted',
  'img_upload_fail': 'Image upload failed',
  'no_img_url': 'No image URL',
  'replace_img_success': 'Image replaced successfully',
  'no_element_selected_or_invalid': 'No element selected or element is invalid',
  'text_cannot_be_empty': 'Text cannot be empty',
  'original_text_cannot_be_empty': 'Original text cannot be empty',
  'cannot_locate_source_file': 'Cannot locate element source file',
  'replace_failed_cannot_locate_file': 'Replace failed: Cannot locate file position',
  'replace_failed': 'Replace failed: {message}',
  'link_cannot_be_empty': 'Link cannot be empty',
  'cannot_get_original_image_url': 'Cannot get original image URL',
  'no_image_selected': 'No image selected',
  'image_size_exceeds_limit': 'Image size cannot exceed 5MB',
  'image_upload_failed': 'Image upload failed',
  'image_processing_failed': 'Image processing failed',
  'send_request_failed': 'Send request failed',
  'sources':'Citations',
  'file_upload_limit_error': 'The maximum number of files that can be uploaded is {filesLength}',
  'copy_image': 'Copy Image',
  'download_full_size': 'Download Full Size',
  'edit_image': 'Quote Image',
  'edit_image_failed': 'Failed to quote image',
  'download_failed': 'Download failed',
  'image_already_added': 'This image has already been added',
  'upgrade_subscription_download_code': 'Upgrade subscription to download full code',
  'tool_calls_empty': 'No tool calls',
  'tool_calls_count': 'Called {count} tools',
  'tool_group_count': 'Called {count} tools',
  'tool_calls_single': 'Called {tool}',
  'tool_calls_summary': 'Called {count} tools: {summary}',
  'todo_progress_step': 'Step {current} / {total}',
  'tool_result_empty': 'No tool result yet',
  'tool_status_success': 'Done',
  'tool_status_running': 'Running',
  'tool_status_failed': 'Failed',
  'tool_status_stopped': 'Stopped',
  'tool_status_warning': 'Warning',
  'tool_status_pending': 'Waiting',
  'tool_summary_seconds': '{seconds}s',
  'tool_detail_files_changed': 'Changed files',
  'tool_detail_commands': 'Commands',
  'tool_detail_logs': 'Execution logs',
  'tool_detail_arguments': 'Arguments',
  'tool_detail_raw_result': 'Raw result',
  'tool_detail_template': 'Framework',
  'tool_detail_project': 'Project Title',
  'tool_detail_install_dependencies': 'Install Dependencies',
  'tool_detail_deploy': 'Deploy',
  'tool_detail_version': 'Version',
  'tool_detail_source': 'Source',
  'tool_detail_response_time': 'Time',
  'tool_detail_continuation': 'Continuations',
  'tool_detail_error': 'Error',
  'tool_batch_query_count': '{count} queries',
  'tool_search_result_count': '{count} results',
  'tool_vertical_domain_count': '{count} domains',
  'tool_vertical_capability_count': '{count} capabilities',
  'tool_extract_content_title': 'Extracted content',
  'clarification_title': 'Clarification',
  'clarification_loading_title': 'Organizing requirements',
  'clarification_loading_desc': 'PAITEAMS is preparing the question card. Please wait.',
  'clarification_progress': '{answered}/{total}',
  'clarification_progress_percent': '{percent}%',
  'clarification_progress_empty': '0/0',
  'clarification_required': 'Required',
  'clarification_multi_select': 'Multi-select',
  'clarification_multi_select_suffix': ' (select all that apply)',
  'clarification_note_placeholder': 'Additional details (optional)',
  'clarification_skip': 'Skip',
  'clarification_prev': 'Previous',
  'clarification_next': 'Next',
  'clarification_submit': 'Submit',
  'tool_name_ask_clarification': 'Clarification',
  'tool_name_ask_user_questions': 'Requirement Check',
  'tool_name_web_search': 'Web Search',
  'tool_name_image_search': 'Image Search',
  'tool_name_image_generation': 'Image Generation',
  'tool_name_video_script_list': 'Video Script Directory',
  'tool_name_video_script_read': 'Read Video Script',
  'tool_name_video_generation_quote': 'Video Generation Quote',
  'tool_name_video_script_save': 'Write Video Script',
  'tool_name_video_generation_execute': 'Generate Video',
  'tool_name_remove_background': 'Remove Background',
  'tool_name_web_image_generation': 'Generate Images',
  'tool_name_web_fetch': 'Web Fetch',
  'tool_name_read_file': 'Read File',
  'tool_name_load_skill': 'Load Skill',
  'tool_skill_visual_design': 'Visual Design',
  'tool_skill_web_development': 'Web Development',
  'tool_reference_design_catalog': 'Design Guidelines Catalog',
  'tool_reference_showcase_catalog': 'Showcase Catalog',
  'tool_reference_design_guideline': 'Design Guideline',
  'tool_reference_design_example': 'Design Example',
  'tool_name_write_file': 'Write File',
  'tool_name_ls': 'List Projects',
  'tool_name_bash': 'Execute Command',
  'tool_name_str_replace': 'Replace Text',
  'tool_name_write_todos': 'Task Steps',
  'tool_name_web_dev_save_project': 'Project Design Brief',
  'tool_name_web_dev_read_project': 'Read Project',
  'tool_name_web_dev_select_template': 'Select Framework',
  'tool_name_web_dev_code_generate': 'Generate Code',
  'tool_name_web_dev_build': 'Build & Deploy',
  'tool_name_batch_search': 'Batch Search',
  'tool_name_extract': 'Read Content',
  'tool_name_get_sub_domains': 'Vertical Search',
  'tool_name_tool_search': 'Tool Search',
  'tool_name_tool': 'Tool',
  'tool_name_query_tool': 'Query Tool',
  'media_canvas': {
    'title': 'Canvas',
    'open': 'Open canvas',
    'close': 'Close canvas',
    'save': 'Save',
    'saving': 'Saving',
    'saved': 'Saved',
    'unsaved': 'Unsaved',
    'save_failed': 'Save failed',
    'version_conflict': 'Canvas version changed. Refresh before saving again.',
    'version_conflict_title': 'File version is out of date',
    'version_conflict_description': 'Your file version is out of date. You may have opened the same project in another browser tab. Refresh the browser to get the latest version.',
    'version_conflict_refresh': 'Refresh',
    'assets': 'Assets',
    'empty_assets': 'No assets yet. Uploaded, pasted, or generated images will appear here.',
    'video': 'Video',
    'video_previews': 'Video previews',
    'video_scripts': 'Video script documents',
    'play_video': 'Play video',
    'pause_video': 'Pause video',
    'video_unavailable': 'Video is unavailable',
    'unnamed_asset': 'Untitled asset',
    'upload_asset': 'Upload asset',
    'close_assets': 'Collapse assets',
    'hide_asset': 'Hide image',
    'show_asset': 'Show image',
    'add_to_chat': 'Add to chat',
    'edit_image': 'Edit image',
    'text_edit_region_label': 'Text region {index}',
    'text_edit': 'Edit text',
    'text_edit_rewrite': 'Rewrite text',
    'text_edit_extract': 'Extract text',
    'text_edit_erase': 'Erase text',
    'text_edit_recognition_in_progress': 'This image is already being recognized. Wait for the current call instead of starting another.',
    'text_edit_model_billing_unavailable': 'Billing configuration for the environment default image model is unavailable. Contact an administrator; models are not switched automatically.',
    'text_edit_request_conflict': 'The request association is inconsistent. Check the original task before retrying to avoid duplicate generation.',
    'text_edit_regions': 'Recognized text regions',
    'text_edit_recognizing': 'Recognizing text…',
    'text_edit_verifying_source': 'Checking the original image…',
    'text_edit_source_verification_unavailable': 'The original image could not be verified. Your recognition result has been kept. Please check again.',
    'text_edit_recheck_source': 'Check again',
    'text_edit_probing_metadata': 'Checking original dimensions and file size…',
    'text_edit_context_unavailable': 'Conversation information is missing; text editing is unavailable',
    'text_edit_missing_metadata': 'Original dimensions or file size are missing. Wait for verification and try again.',
    'text_edit_metadata_failed': 'Could not verify the original image. Tap this hint or reselect the image to retry.',
    'text_edit_source_timeout': 'Reading the original image timed out. Please try again later.',
    'text_edit_source_unavailable': 'Could not read the original image. Please try again later.',
    'text_edit_source_decode_failed': 'The original image format or content is invalid. Please upload the image again.',
    'text_edit_source_too_large': 'Text editing requires an original image with a long edge ≤ 3840px, short edge ≤ 2160px, and file size ≤ 10MB.',
    'text_edit_missing_url': 'A valid original image URL is missing',
    'text_edit_unsupported_format': 'Text editing only supports the existing canvas JPG, PNG, and WEBP formats',
    'text_edit_no_text': 'No text recognized.',
    'text_edit_select_region': 'Select one complete text region on the image',
    'text_edit_recognized_text': 'Recognized text (please verify)',
    'text_edit_new_text': 'Replacement text',
    'text_edit_new_text_placeholder': 'Enter the replacement text',
    'text_edit_rewrite_submit': 'Apply changes',
    'text_edit_erase_submit': 'Erase selected text',
    'text_edit_erase_confirm': 'Erase only the selected text and repair its background. The result is inserted beside the unchanged original.',
    'text_edit_generation_hint': 'Complex backgrounds may reduce quality. Fonts, perspective, colors, and generated text may not match exactly. The result is inserted beside the original.',
    'text_edit_copy': 'Copy text',
    'text_edit_copied': 'Text copied',
    'text_edit_manual_copy': 'Long-press or use your keyboard shortcut to copy.',
    'text_edit_recognize_again': 'Recognize again',
    'text_edit_recognize_again_hint': 'Recognizing again makes a new OCR call, billed according to actual usage',
    'text_edit_check_status': 'Check task status',
    'text_edit_checking': 'Checking…',
    'text_edit_check_unconfirmed': 'The result is still unconfirmed. Keep checking, or end the wait when available.',
    'text_edit_query_failed': 'Status check failed. Check your connection or try again later. The task will not regenerate automatically.',
    'text_edit_query_timeout': 'Status check timed out. Try again later; this does not mean generation failed.',
    'text_edit_query_succeeded': 'The original task completed and its result has been restored.',
    'text_edit_last_check': 'Last checked at {time}: {status}',
    'text_edit_end_wait': 'End wait',
    'text_edit_end_wait_confirm': 'Ending this wait allows you to generate again manually, but does not guarantee that the provider canceled the original request. A new generation may incur another charge. End this wait?',
    'text_edit_wait_ended': 'Waiting ended. Select the text and generate again manually.',
    'text_edit_recovery_action_required': 'Task status checks are paused. Check your sign-in or access permissions, then try again.',
    'text_edit_multiline_hint': 'This region contains multiple lines. Adjacent regions are not merged; verify the line breaks.',
    'text_edit_edge_hint': 'The text is close to an image edge. Limited background context may reduce generation quality.',
    'text_edit_vertical_hint': 'This region may contain vertical text. Verify its content and layout; generation quality may be lower.',
    'text_edit_tilted_hint': 'This text may be tilted or have perspective distortion, which can reduce generation quality.',
    'text_edit_crop_hint': 'Regions outside the crop or cut off by it cannot be selected. Adjust the image crop first.',
    'text_edit_invalid_regions_hint': 'Some regions have invalid coordinates or duplicate IDs and were skipped. Incorrect coordinates will not be used.',
    'text_edit_invalid_ocr': 'The recognition coordinates or source association are invalid. Recognize again before editing.',
    'text_edit_empty_text': 'Text cannot be empty. Use Erase text to remove it.',
    'text_edit_same_text': 'The text is unchanged; generation is unnecessary.',
    'text_edit_text_too_long': 'Text is too long. Shorten it before applying.',
    'text_edit_protected_overlap': 'This region overlaps unselected text and cannot be edited alone.',
    'text_edit_unsafe_region': 'This region cannot be edited safely. Check the recognized area.',
    'text_edit_overlap_conflict': 'Text boxes at the same position have different replacements and cannot be edited together.',
    'text_edit_local_input_limit': 'The source image dimensions, ratio or file size do not meet the default model’s text-editing limits.',
    'text_edit_processing': 'Text editing is in progress. Please wait.',
    'text_edit_submitting': "Submitting…",
    'text_edit_timeout': "Image editing timed out. The placeholder was removed. You can try again.",
    'text_edit_wait_connection': "Waiting has ended. The task will be checked automatically when the connection returns before allowing another generation.",
    'text_edit_busy': 'Another request is being processed. Try again shortly.',
    'text_edit_failed': 'Text processing failed. Check the input and try again.',
    'text_edit_generation_failed_retry': 'Generation failed. Please try again.',
    'text_edit_unknown': 'Generation failed. Please try again.',
    'text_edit_result_unconfirmed': 'Automatically checking the text editing result. Please wait.',
    'text_edit_tool_unavailable': 'The default OCR tool is unavailable. Contact an administrator.',
    'text_edit_model_unavailable': 'The environment default image model is missing or unavailable. Contact an administrator.',
    'text_edit_model_unsupported': 'The default model cannot edit images. Contact an administrator.',
    'text_edit_recognition_expired': 'Recognition expired. Recognize again.',
    'text_edit_source_changed': 'The source image or its original dimensions changed. Reselect the image and recognize again.',
    'text_edit_recognition_failed': 'Text recognition failed. Please try again later.',
    'text_edit_recognition_unknown': 'Text recognition failed. Please try again.',
    'text_edit_content_rejected': 'The image or replacement text did not pass content review. Adjust it before retrying.',
    'text_edit_rate_limited': 'Too many text-service requests. Try again later.',
    'text_edit_points_insufficient': 'Insufficient points. Top up and try again.',
    'text_edit_service_unavailable': 'Text editing is temporarily unavailable. Try again later.',
    'expand': 'Expand image',
    'expand_title': 'Expand image',
    'expand_description': 'Choose the final canvas ratio. The original image stays centered without cropping or stretching.',
    'expand_drag_hint': 'Drag an edge or corner to adjust the expansion area',
    'expand_ratio_too_large': 'This ratio exceeds the 5824px edge limit. Drag to adjust the area.',
    'expand_custom': 'Custom',
    'expand_width': 'Width',
    'expand_height': 'Height',
    'expand_submit': 'Expand',
    'expand_source_too_large': 'The source image\'s longest edge exceeds 4160 pixels. Image expansion is unavailable.',
    'expand_custom_invalid': 'Enter integer dimensions from 1 to 5824',
    'expand_custom_must_contain': 'Custom canvas dimensions cannot be smaller than the source image',
    'expand_target_unreachable': 'This size and source image position cannot be expanded. Adjust the dimensions or image position.',
    'expand_round_limit': 'This expansion area requires too many rounds. Reduce the area or adjust the image position.',
    'expand_no_change': 'The target size matches the source image. Increase the expansion area.',
    'expand_failed_retry': 'Image expansion failed. Please try again.',
    'edit_prompt_placeholder': 'Describe how you want to edit this image',
    'high_definition': 'Upscale',
    'high_definition_output_size': 'Choose the scale and output size',
    'high_definition_scale': '{scale}x',
    'high_definition_preserve_alpha': 'Transparency will be preserved when possible',
    'high_definition_limit_option': 'Neither output edge can exceed {max} pixels',
    'high_definition_invalid_selection': 'Select one ready image',
    'high_definition_missing_url': 'This image has no valid asset URL',
    'high_definition_unsupported_format': 'Upscaling supports JPG, PNG, and WEBP images only',
    'high_definition_missing_dimensions': 'Original dimensions are unavailable. Try again after server inspection.',
    'high_definition_probing_dimensions': 'Inspecting the original image dimensions',
    'high_definition_limit_reached': 'This image has reached the {max}-pixel service limit and cannot be enlarged',
    'high_definition_failed_retry': 'Upscaling failed. Please try again.',
    'high_definition_source_too_large': 'The image exceeds 20 MB. Please compress it and try again.',
    'high_definition_status_uncertain': 'The task status is not confirmed yet. Retrying will reuse the original task.',
    'remove_background_prompt': 'Remove the background from this image and return it with a transparent background.',
    'remove_background_failed_retry': 'Background removal failed. Please generate it again.',
    'eraser': 'Eraser',
    'eraser_title': 'Eraser',
    'eraser_description': 'Paint the area to remove. The original image will not be overwritten.',
    'eraser_brush': 'Brush',
    'eraser_mask_eraser': 'Mask eraser',
    'eraser_brush_size': 'Brush size',
    'eraser_undo': 'Undo',
    'eraser_redo': 'Redo',
    'eraser_reset': 'Reset',
    'eraser_mask_hint': 'White areas are removed; black areas are preserved.',
    'eraser_submit': 'Generate',
    'eraser_missing_image': 'This image has no editable asset URL',
    'eraser_missing_dimensions': 'Original image dimensions are unavailable',
    'eraser_source_too_large': 'This image exceeds the eraser processing range. Please compress it and try again.',
    'eraser_bria_source_too_large': 'The source image exceeds 30 MB. Please compress it and try again.',
    'eraser_capabilities_unavailable': 'Eraser configuration is unavailable or no default tool is configured. The server tool cannot be verified safely. Check backend configuration and retry.',
    'eraser_capabilities_legacy_fallback': 'The latest eraser configuration is unavailable. Editing uses the previous limits (2560 × 1440, 10 MB); the provider has not changed. Retry later for large BRIA images.',
    'eraser_resource_unavailable': 'This browser cannot process the image at its original size. Try a device with more memory. The image has not been resized.',
    'eraser_image_load_failed': 'Failed to load the image. Try again.',
    'eraser_mask_export_failed': 'Failed to export the mask. Try again.',
    'eraser_invalid_input': 'The image or mask dimensions are invalid. Edit the mask and try again.',
    'eraser_service_unavailable': 'The eraser service is temporarily unavailable.',
    'eraser_rate_limited': 'The service is busy. Please try again later.',
    'eraser_content_rejected': 'This image or removal area does not meet the service rules.',
    'eraser_result_unknown': 'The result is not confirmed yet. Check the task status later.',
    'eraser_failed_retry': 'Removal failed. Please generate it again.',
    'untitled': 'Untitled canvas',
    'need_conversation': 'Create a conversation before adding canvas assets',
    'upload_missing_url': 'Upload succeeded but no file URL was returned',
    'asset_create_failed': 'Failed to create asset',
    'asset_rename_failed': 'Failed to rename asset',
    'asset_delete_failed': 'Failed to delete the asset. Try again.',
    'export': {
      'open': 'Export',
      'close': 'Close export',
      'title': 'Export',
      'export_type': 'Export type',
      'image': 'Image',
      'format': 'Image format',
      'original_format': 'Original format (automatic)',
      'size': 'Export size',
      'original_size': 'Original size',
      'scale_value': '{scale}x',
      'download_range': 'Download range',
      'download_content': 'Download content',
      'download_count': 'Download items {count}',
      'all_selected_content': 'Select all images',
      'max_selected_assets': 'Select up to {count} images per export',
      'selection_limit_reached': 'You cannot select more than {max} images.',
      'export_mode': 'Export mode',
      'separate': 'Download separately',
      'long_image': 'Combine into one',
      'separate_detail': 'Images are processed separately and packaged in a ZIP file',
      'watermark': 'LOGO',
      'logo_watermark': 'Platform LOGO',
      'membership_required': 'Required on Basic',
      'watermark_position': 'LOGO position',
      'position_top_left': 'Top left',
      'position_top_center': 'Top center',
      'position_top_right': 'Top right',
      'position_middle_left': 'Left',
      'position_center': 'Center',
      'position_middle_right': 'Right',
      'position_bottom_left': 'Bottom left',
      'position_bottom_center': 'Bottom center',
      'position_bottom_right': 'Bottom right',
      'kicker': 'Canvas export workspace',
      'asset_hint': 'Select images and tune each export independently',
      'output_settings': 'Output settings',
      'output_settings_hint': 'Format and scale apply to this export',
      'pixel_width': 'Image width (px)',
      'pixel_height': 'Image height (px)',
      'lock_aspect_ratio': 'Lock aspect ratio',
      'resize_mode': 'Resize mode',
      'resize_mode_exact': 'Width and height match',
      'resize_mode_width': 'Width matches',
      'resize_mode_height': 'Height matches',
      'resize_mode_fit': 'Fit proportionally',
      'image_apply_mode': 'Apply mode',
      'image_properties': 'Image properties',
      'image_properties_hint': 'Each image can have its own settings',
      'apply_single': 'Apply to image',
      'apply_selected_all': 'Apply to all selected',
      'sync_properties_to_selected_images': 'Apply to selected images',
      'apply_image_settings': 'Apply',
      'sync_logo_to_selected_images': 'Sync LOGO to all selected images',
      'apply_image_to_selected': 'Apply pixels to selected',
      'custom_watermark': 'Personal LOGO',
      'custom_watermark_hint': 'Upload a personal LOGO and drag it in the preview',
      'watermark_image': 'LOGO image',
      'no_watermark_short': 'No LOGO',
      'no_custom_watermark': 'Do not add a personal LOGO',
      'upload_watermark': 'Upload LOGO',
      'uploading_watermark': 'Uploading',
      'watermark_upload_success': 'LOGO added',
      'watermark_upload_failed': 'LOGO upload failed. Try again.',
      'delete_watermark': 'Delete {name}',
      'watermark_delete_title': 'Delete LOGO',
      'watermark_delete_confirm': 'Delete “{name}”? It will no longer be available for exports.',
      'watermark_delete_confirm_button': 'Delete',
      'watermark_delete_success': 'LOGO deleted',
      'watermark_delete_failed': 'LOGO deletion failed. Try again.',
      'watermark_format_invalid': 'Use a PNG, JPG, or WEBP LOGO',
      'watermark_file_too_large': 'LOGO files must be under 5MB',
      'watermark_rotation': 'LOGO rotation (°)',
      'watermark_opacity': 'LOGO opacity (%)',
      'drag_watermark': 'Drag the LOGO in the preview to reposition it',
      'resize_watermark': 'Drag a LOGO corner to resize it',
      'watermark_position_hint': 'Use a shortcut or drag the LOGO in the preview',
      'watermark_pixel_settings': 'LOGO pixels',
      'advanced_settings': 'Advanced settings',
      'watermark_pixel_settings_hint': 'Set LOGO position and size in output pixels',
      'watermark_pixel_x': 'LOGO X (px)',
      'watermark_pixel_y': 'LOGO Y (px)',
      'watermark_pixel_width': 'LOGO width (px)',
      'watermark_pixel_height': 'LOGO height (px)',
      'image_setting_uniform': 'Image uniform',
      'image_setting_individual': 'Image individual',
      'logo_setting_uniform': 'Logo uniform',
      'logo_setting_individual': 'Logo individual',
      'no_logo': 'No logo',
      'cancel': 'Cancel',
      'submit': 'Export',
      'exporting': 'Exporting',
      'exporting_progress': 'Exporting {current}/{total}',
      'export_progress_estimate': 'Estimated progress',
      'export_progress_preparing': 'Preparing export',
      'export_progress_rendering': 'Processing assets',
      'export_progress_packaging': 'Finalizing file',
      'export_progress_complete': 'Export complete',
      'empty_canvas': 'There are no exportable images in the asset library',
      'save_before_export_failed': 'The canvas could not be saved, so it cannot be exported yet',
      'export_success': 'Export complete',
      'download_url_missing': 'The export completed without a download URL. Please try again.',
      'subscription_required': 'Upgrade your subscription to export the canvas',
      'export_failed': 'Export failed. Try again.',
      'processing_failed': 'Export processing failed. Please try again.',
      'processing_timeout': 'Export processing exceeded 600 seconds. Please try again later.',
      'no_images_selected': 'Select at least one image',
      'invalid_export_mode': 'Invalid export mode. Please choose again.',
      'invalid_export_format': 'Invalid image format. Please choose again.',
      'invalid_export_scale': 'Invalid export scale. Please choose again.',
      'invalid_export_asset_ids': 'Invalid image selection. Please choose again.',
      'invalid_export_asset_mode': 'Single-image exports require one image; choose separate or long-image mode for multiple images.',
      'invalid_export_manifest': 'Invalid export image settings. Please configure them again.',
      'invalid_resize_mode': 'Invalid image resize mode. Please choose again.',
      'limit_asset_count': 'Select no more than {max} images per export.',
      'limit_mode_count': 'Single-image export requires 1 image; multi-image export requires at least 2 images.',
      'limit_long_asset_count': 'Select no more than {max} images for a long image.',
      'limit_output_dimension': 'Output width and height must be positive integers.',
      'limit_output_edge': 'Each output edge must be no more than {maxEdge}px.',
      'limit_per_image_pixels': 'Each output image cannot exceed 67,240,000 pixels (about 67.24MP; 8,200 × 8,200).',
      'pixel_limit_single': 'Single-image output: width and height must each be ≤13,000px, with no more than 67,240,000 pixels (about 67.24MP; 8,200 × 8,200);',
      'limit_source_edge': 'Each source-image edge must be no more than {maxSourceEdge}px.',
      'limit_source_pixels': 'A source image cannot exceed 67,240,000 pixels (about 67.24MP; for example, 8,200 × 8,200).',
      'limit_separate_pixels': 'The combined output pixels for separate downloads cannot exceed 1,280,000,000 (1280MP).',
      'limit_long_pixels': 'The combined long-image canvas cannot exceed 67,108,864 pixels.',
      'limit_source_file_size': 'Each source file must be no larger than 100MiB.',
      'limit_source_total_size': 'The total source download must be no larger than 1,024MiB (1GiB).',
      'pixel_limit_per_image': 'Each image in separate or long-image output must have width and height ≤13,000px, with no more than 67,240,000 pixels per image (about 67.24MP; 8,200 × 8,200);',
      'pixel_limit_separate': 'Separate downloads must total ≤1,280,000,000 pixels;',
      'pixel_limit_long': 'Long images use “max width × total height”; the canvas must be ≤67,108,864 pixels.',
      'scroll_load_more': 'Scroll down to load more images'
    }
  }
}
